import script from "./SavedHeatmapsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SavedHeatmapsPanel.vue?vue&type=script&setup=true&lang=js"

import "./SavedHeatmapsPanel.vue?vue&type=style&index=0&id=1418972c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1418972c"]])

export default __exports__